const tiktokAuthApiUrl = "https://www.tiktok.com/v2/auth/authorize/";
const scope = "user.info.basic,video.publish,video.upload";

const tiktokSettings = {
  dev: {
    tiktokAuthApiUrl,
    clientKey: "sbawmqgxtu7a6owfyv",
    redirectUri: "https://08e3-2607-fea8-68e0-9b00-00-ba1c.ngrok-free.app/callbacks/tiktok",
    scope,
    response_type: "code",
  },
  stage: {
    tiktokAuthApiUrl,
    clientKey: "sbawmqgxtu7a6owfyv",
    redirectUri: "https://stage.mymediaplanner.com/callbacks/tiktok",
    scope,
    response_type: "code",
  },
  prod: {
    tiktokAuthApiUrl,
    clientKey: "awtt4icua3vvxftr",
    redirectUri: "https://mymediaplanner.com/callbacks/tiktok",
    scope,
    response_type: "code",
  },
};

const getTiktokSettings = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "stage":
      return tiktokSettings.stage;
    case "prod":
      return tiktokSettings.prod;
    default:
      return tiktokSettings.dev;
  }
};

export default getTiktokSettings;
